// PrintOnlyStyles.jsx
import React from 'react';

export default function PrintOnlyStyles() {
  return (
    <style>
      {`
        @page { margin: 12mm; }
        @media print {
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          /* hide everything */
          body * { visibility: hidden !important; }
          /* show only the printable area */
          #printable, #printable * { visibility: visible !important; }
          #printable {
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
            width: 100% !important;
            font-family: 'Graphik', Helvetica Neue, Helvetica, Arial, sans-serif !important;
          }
          #printable * {
            font-family: inherit !important;
          }
        }
      `}
    </style>
  );
}

// utils/printSamePage.js
export async function printSamePage(target = '#printable', opts = {}) {
  const options = {
    ...opts,
    delay: 60,
    timeout: 4000,
  };
  const container =
    typeof target === 'string' ? document.querySelector(target) : target;
  if (!container) return;

  // 1) Wait for images inside the container
  const imgs = container.getElementsByTagName('img');
  const imgPromises = [];
  for (let i = 0; i < imgs.length; i += 1) {
    const img = imgs[i];

    if (img.complete) {
      if (typeof img.decode === 'function') {
        imgPromises.push(img.decode().catch(() => {}));
      }
    } else {
      imgPromises.push(
        new Promise(resolve => {
          const done = () => {
            img.removeEventListener('load', done);
            img.removeEventListener('error', done);
            resolve();
          };
          img.addEventListener('load', done);
          img.addEventListener('error', done);
        })
      );
    }
  }

  // 2) Wait for web fonts (if supported)
  let fontsReady = Promise.resolve();
  if (
    typeof document !== 'undefined' &&
    document.fonts &&
    document.fonts.ready &&
    typeof document.fonts.ready.then === 'function'
  ) {
    fontsReady = document.fonts.ready.catch(() => {});
  }

  // 3) Don't hang forever on bad assets
  const assetsReady = Promise.race([
    Promise.all(imgPromises),
    new Promise(resolve => {
      setTimeout(resolve, options.timeout);
    }),
  ]);

  await Promise.all([assetsReady, fontsReady]);

  // 4) Let the browser flush layout twice before printing
  await new Promise(res1 => {
    requestAnimationFrame(() => {
      requestAnimationFrame(res1);
    });
  });

  // 5) Small delay helps some engines apply @media print rules
  setTimeout(() => window.print(), options.delay);
}
